export enum FilterFieldsKeys {
  CreatedDate = 'createdDate',
  LastModifiedDate = 'lastModifiedDate',
  Chain = 'chain',
  AssetName = 'assetName',
  BatchID = 'batchId',
  OperationType = 'operationType',
  Status = 'status',
  MerchantIds = 'merchantNames',
}

export interface FilterFields {
  [FilterFieldsKeys.Chain]: string;
  [FilterFieldsKeys.AssetName]: string[];
  [FilterFieldsKeys.BatchID]: string;
  [FilterFieldsKeys.OperationType]: string;
  [FilterFieldsKeys.Status]: string;
  [FilterFieldsKeys.MerchantIds]: string[];
}
